/**
 * Detects if text is WebVTT format and converts it to LRC format.
 * VTT format:
 *   WEBVTT
 *   00:00.000 --> 00:06.780
 *   Welcome to the story.
 *
 * LRC format:
 *   [00:00.00]Welcome to the story.
 */
function convertVttToLrc(text) {
  if (!text || typeof text !== 'string') return text;

  // Check if text looks like VTT (has --> timestamps)
  if (!text.includes('-->')) return text;

  const lines = text.replace(/\r\n/g, '\n').split('\n');
  const result = [];

  let i = 0;
  // Skip WEBVTT header and any metadata lines
  while (i < lines.length) {
    const trimmed = lines[i].trim();
    if (trimmed === 'WEBVTT' || trimmed === '' || trimmed.startsWith('NOTE')) {
      i++;
      continue;
    }
    // Skip numeric cue identifiers (just a number on its own line)
    if (/^\d+$/.test(trimmed)) {
      i++;
      continue;
    }
    break;
  }

  while (i < lines.length) {
    const line = lines[i].trim();

    // Skip empty lines
    if (line === '') {
      i++;
      continue;
    }

    // Skip numeric cue identifiers
    if (/^\d+$/.test(line)) {
      i++;
      continue;
    }

    // Check for timestamp line: 00:00.000 --> 00:06.780
    const tsMatch = line.match(/^(\d{1,2}:)?(\d{2}):(\d{2})\.(\d{1,3})\s*-->/);
    if (tsMatch) {
      // Parse start time
      const hours = tsMatch[1] ? parseInt(tsMatch[1].replace(':', ''), 10) : 0;
      const minutes = parseInt(tsMatch[2], 10) + hours * 60;
      const seconds = parseInt(tsMatch[3], 10);
      const ms = tsMatch[4].padEnd(3, '0').slice(0, 2); // Take first 2 digits for LRC centiseconds

      const lrcTime = `[${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}.${ms}]`;

      // Collect lyrics text (all lines until next empty line or next timestamp)
      i++;
      const lyricParts = [];
      while (i < lines.length) {
        const nextLine = lines[i].trim();
        if (nextLine === '' || nextLine.match(/^(\d{1,2}:)?\d{2}:\d{2}\.\d{1,3}\s*-->/) || /^\d+$/.test(nextLine)) {
          break;
        }
        lyricParts.push(nextLine);
        i++;
      }

      if (lyricParts.length > 0) {
        result.push(lrcTime + lyricParts.join(' '));
      }
    } else {
      i++;
    }
  }

  return result.length > 0 ? result.join('\n') : text;
}

export default convertVttToLrc;
